import api from "../index";

export const GetAllTraderApi = (params) => api.get(`admin/getalluserlist?${params}`);
export const AddTraderApi = (data) => api.post('admin/add-trader', data);
export const GetTraderByIdApi = (traderId) => api.get(`admin/getsingleuser/${traderId}`);
export const GetTraderAccountsByIdApi = (traderId, params) => api.get(`usermaster/admin/vertex-account-trader/${traderId}?${params}`);
export const GetUserPasswordApi = (params) => api.post('usermaster/get-trader-password', params);

export const GetTraderaccountByIdApi = (terminalId) => api.get(`trading/get-account-byid/${terminalId}`);
export const GetIBUserDetailsApi = (userId) => api.get(`admin/getsingleibuser/${userId}`);
export const GetIBTreeApi = (userId) => api.get(`ibusermaster/get-ibtree/${userId}`);
export const GetParentTreeApi = (userId) => api.get(`ibusermaster/get-parent-ibtree/${userId}`);

export const GetTraderAccountTransactionApi = (terminalId) => api.get(`trading/get-closed-trades/${terminalId}`);
export const GetAssignableRulesApi = () => api.get('rulemaster/getallrule-byuser');
export const AssignUserRuleApi = (data) => api.post('rulemaster/assignrule', data);
export const GetAssignedRulesApi = (userId) => api.get(`rulemaster/getruleforassign/${userId}`);
export const GetClientProfileApi = (userId) => api.get(`trading/get-client-info/${userId}`);
export const UnassignUserRuleApi = (data) => api.post('rulemaster/unassignrule', data);

export const UpdateUserStatusApi = (data) => api.put('usermaster/toogle-user-activation', data);
export const Downloadclientdetails = (traderId) => api.get(`Admin/Get-User-Profile-Pdf/${traderId}`);
export const UpdateTraderApi = (data) => api.put('Admin/Update-UserProfile', data);
export const Verificationemaillink = (userId) => api.get(`usermaster/send-verification-email/${userId}`);
export const UpdateIBStatusApi = (params) => api.patch('usermaster/change-ibuser-status', params);
export const ChangeCRMPasswordApi = (data) => api.post('authentication/admin/change-password', data);

// V2fx account
export const GetPlansForUserApi = (params) => api.post('planmaster/get-all-plan-for-user', params);
export const CreateV2fxAccountApi = (data) => api.post('trading/admin/create-trading-account', data);
export const UpdateV2fxAccountV2fxApi = (data) => api.put('trading/trading-leverage-change', data);
export const UpdateV2fxAccountPasswordApi = (data) => api.put('trading/trading-change-password', data);
export const VerifyLoginPasswordApi = (data) => api.post('usermaster/verify-password', data);
export const AddV2fxAccountbalanceApi = (data) => api.post('trading/trading-demo-account-deposit', data);

// Deposit
export const GetPaymentGatewayApi = () => api.get('paymentgateway/get-payment-gateway');
export const DepositAmountApi = (data) => api.post('wallet/Zaropay-Payment-Deposit', data);
export const GetPaymentGatewayByIdApi = (paymentGatewayId) => api.get(`paymentgateway/payment-gatewaybyid/${paymentGatewayId}`);

export const AddDepositWithdrawRequestApi = (data) => api.post('admin/admin-deposit-withdraw-request', data);
export const VerifyDepositWithdrawOtpApi = (data) => api.post('admin/admin-deposit-withdraw-verify-otp', data);

// Withdraw
export const GetWithdrawRequestApi = (userId, params) => api.get(`wallet/getall-withdrawrequests-byuerid/${userId}?${params}`);
export const GetWalletApi = (userId, params) => api.get(`wallet/admin/payment-gatway-rule-details/${userId}?${params}`);
export const AddWithdrawRequestApi = (data) => api.post('wallet/add-withdraw-request', data);
export const GetPaymentGatewayStatusByIdApi = (params) => api.get(`wallet/Get-Zaropay-Payment-Status?${params}`);

// Internal-Transfer
export const WalletToAccountTransferApi = (data) => api.post('WalletMaster/Internal-Transfer-Wallet-to-Terminal', data);
export const AccountToWalletTransferApi = (data) => api.post('WalletMaster/Internal-Transfer-Terminal-to-Wallet', data);
export const GetMT5AccountsApi = (userId) => api.get(`DropDown/GetUserLive-MTFiveAccount/${userId}`);
export const GetAlllogsApi = (userId, params) => api.get(`admin/get-audit-log-by-userid/${userId}?${params}`);
export const V2fxCredentialsManageApi = (data, headers) => api.post('admin/send-vertex-credentials', data, headers);
export const SendUserCredentialsApi = (userId) => api.get(`usermaster/send-user-password-details/${userId}`);
export const NotificationApi = (data, headers) => api.post('notification/send-notification', data, headers);
export const SendIBRequestApi = (data) => api.post('admin/ibrequest', data);
export const GetIBUsersListApi = (params) => api.get(`admin/getallibuserlist?${params}`);
export const UpdateIBApi = (params) => api.post(`IBMaster/Update-User-Level?${params}`);
export const DeleteUserApi = (userId) => api.delete(`usermaster/delete-user/${userId}`);
